<div class="row no-gutters row-eq-height product">
	<div class="col-4 master_image" *ngIf='cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(' + appService.getBaseServerAddress() + '/document_files/resize/1024x768/' + cartItem.target_info.master_image_item + ')'}"></div>
	<div class="col-4 master_image" *ngIf='!cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(assets/img/1024x768.png)'}"></div>
	<div class="col-8 cart-info">
		<h4>
			<span class="item-name">
				<a [routerLink]="['/d', appService.domainId, 'detail', 'products', cartItem.product_id]">
					{{cartItem.target_info.display_name_item}}
				</a>
			</span>
		</h4>

		<div class="participants">
			<form *ngIf='formGroup' id="product-form" autocomplete="off" [formGroup]='formGroup'>
				<div class="inner">
					<input type="button" title="Reduce Quantity" value="-" class="qty-minus" data-field="quantity" (click)='decrement()'>
					<input type="number" formControlName="ADT" min="1" step="1" class="qty" />
					<input type="button" title="Increase Quantity" value="+" class="qty-plus" data-field="quantity" (click)='increment()'>
				</div>
			</form>
		</div>

		<div class="tour-date">{{cartItem.date | date: 'dd/MM/yyyy'}}</div>

		<div class="prices-item">
			<div [ngClass]="{'item-price': true, 'line-through': cartItem.target_info.total_price_item > cartItem.trip_booking.total_amount}">
				{{ cartItem.target_info.total_price_item | currency:'EUR' }}
			</div>
			<div class="discounted-price" *ngIf='cartItem.target_info.total_price_item > cartItem.trip_booking.total_amount'>
				{{ cartItem.trip_booking.total_amount | currency:'EUR' }}
			</div>
		</div>

		<div class="remove-item" (click)='cartService.removeItem(cartItem.id)'>
			{{'Rimuovi' | translate}}
		</div>
	</div>
</div>